var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.357422,
    width: 27.1194,
    height: 26,
    rx: 13,
    fill: "#3C406B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9395 18.5791H19.2145L10.9877 7.34887H9.61995L17.9395 18.5791ZM18.7468 6.00136H21.0472L16.0222 11.9312L21.9336 20H17.3054L13.6795 15.1063L9.53132 20H7.2295L12.605 13.6568L6.93359 6H11.6804L14.9572 10.4736L18.7468 6V6.00136Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.b33f345235d8befbd0b08e361ffb736c.svg";
export { ForwardRef as ReactComponent };